import { dot, undot } from './object'

// https://github.com/vuejs/vuex/issues/335
// https://jsfiddle.net/bjahdbx5/2/

function mapValues (obj, f) {
    const res = {}

    Object.keys(obj).forEach(key => {
        res[key] = f(obj[key], key)
    })

    return res
}

export default (module, types) => {
    return undot(mapValues(dot(types), (value, key) => {
        return `${module}:${key}:${value}`
    }))
}
